<template>
  <div>
    <el-row>
      <el-col :span="16">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>库存信息</span>
            <div>
              <el-button type="primary" size="small" @click="_goBack">返回</el-button>
            </div>
          </div>
          <el-table
            :data="productStockManageInfo.productStocks"
            style="width: 100%"
            border
            stripe>
            <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="barCode" label="条形码" align="center"></el-table-column>
            <el-table-column prop="createTime" label="入库时间" align="center"></el-table-column>
            <el-table-column prop="state" label="状态" align="center">
              <template slot-scope="scope">
                {{scope.row.state=='1001'?'正常':'占用'}}
              </template>
            </el-table-column>
            <el-table-column prop="createUserName" label="入库人" align="center"></el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="_openDeleteProductStockModel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="productStockManageInfo.conditions.page"
            :page-size="productStockManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="productStockManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询库存</span>
          </div>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="条形码">
              <el-input 
                v-model="productStockManageInfo.conditions.barCode" 
                placeholder="必填，请填写条形码"
                @keyup.enter.native="_queryProductMethod"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryProductMethod">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="box-card" style="margin-top: 20px;">
          <div slot="header" class="flex justify-between">
            <span>入库信息</span>
          </div>
          <el-form label-width="80px">
            <el-form-item label="条形码">
              <el-input 
                v-model="productStockManageInfo.barCode" 
                id="enterBarCode"
                placeholder="必填，请填写条形码"
                @keyup.enter.native="_enterProductStock"></el-input>
            </el-form-item>
            <el-form-item label="商品">
              <span>{{productStockManageInfo.prodName}}</span>
            </el-form-item>
            <el-form-item>
              <el-button 
                type="warning" 
                size="large" 
                style="width: 100%;"
                @click="_enterProductStock">入库</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <delete-product-stock ref="deleteProductStock"></delete-product-stock>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryProductStock, saveProductStock, queryProduct } from '@/api/goods/productStockApi'

export default {
  name: 'ProductStockManage',
  data() {
    return {
      productStockManageInfo: {
        productStocks: [],
        total: 0,
        records: 1,
        moreCondition: false,
        barCode: '',
        prodName: '',
        conditions: {
          productId: '',
          valueId: '',
          keyword: '',
          barCode: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
    this.productStockManageInfo.conditions.productId = this.$route.query.productId
    this.productStockManageInfo.conditions.valueId = this.$route.query.valueId
    this._listProducts()
    this._listProductStocks(1, 10)
  },
  methods: {
    _initData() {
      this.productStockManageInfo.conditions.shopId = getShopId()
      document.getElementById("enterBarCode").focus()
    },
    handleCurrentChange(val) {
      this._listProductStocks(val, this.productStockManageInfo.conditions.row)
    },
    async _listProductStocks(page, rows) {
      this.productStockManageInfo.conditions.page = page
      this.productStockManageInfo.conditions.row = rows
      
      try {
        const res = await queryProductStock(this.productStockManageInfo.conditions)
        this.productStockManageInfo.total = res.total
        this.productStockManageInfo.records = res.records
        this.productStockManageInfo.productStocks = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openDeleteProductStockModel(product) {
      this.$refs.deleteProductStock.open(product)
    },
    _queryProductMethod() {
      this._listProductStocks(1, this.productStockManageInfo.conditions.row)
    },
    async _listProducts() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 1,
          productId: this.productStockManageInfo.conditions.productId
        })
        const product = res.data[0]
        this.productStockManageInfo.prodName = product.prodName
        this.productStockManageInfo.barCode = ''
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _enterProductStock() {
      if (!this.productStockManageInfo.barCode) {
        this.$message.error('条形码不能为空')
        return
      }

      const params = {
        shopId: getShopId(),
        barCode: this.productStockManageInfo.barCode,
        productId: this.productStockManageInfo.conditions.productId,
        valueId: this.productStockManageInfo.conditions.valueId
      }

      try {
        const res = await saveProductStock(params)
        this.productStockManageInfo.barCode = ''
        if (res.code === 0) {
          this.$message.success('入库成功')
          this._listProductStocks(1, this.productStockManageInfo.conditions.row)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error(error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.el-col {
  padding: 0 10px;
}
.box-card {
  margin-bottom: 20px;
}
</style>